// extracted by mini-css-extract-plugin
export default {"successMessage":"UserForm_successMessage__7HRW9","errorMessage":"UserForm_errorMessage__JfPji"};